import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
		fill: "#E7F4FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.625 28.75C25.4721 28.7504 25.3244 28.6949 25.2098 28.5938L20 23.9613L14.7902 28.5938C14.7001 28.6739 14.5887 28.7262 14.4694 28.7445C14.3502 28.7627 14.2282 28.746 14.1182 28.6964C14.0083 28.6469 13.915 28.5666 13.8496 28.4652C13.7843 28.3638 13.7497 28.2456 13.75 28.125V13.75C13.7507 13.0872 14.0144 12.4517 14.483 11.983C14.9517 11.5143 15.5872 11.2507 16.25 11.25H23.75C24.4128 11.2507 25.0483 11.5143 25.517 11.983C25.9857 12.4517 26.2493 13.0872 26.25 13.75V28.125C26.25 28.2908 26.1842 28.4497 26.0669 28.5669C25.9497 28.6842 25.7908 28.75 25.625 28.75Z",
		fill: "#2171C6"
	})]
});
export default SvgBookmarked;
